import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

//【首页】
import HomeView from '@/views/HomeView.vue'//首页✅

//【产品服务】
import P21S from '@/views/product/automotive/P21S.vue'//卫惯系列/车规级卫惯产品/P21S
import INM11 from '@/views/product/automotive/INM11.vue'//卫惯系列/车规级卫惯产品/INM11
import GNM11 from '@/views/product/automotive/GNM11.vue'//卫惯系列/车规级卫惯产品/GNM11
import AutomotiveIndex from '@/views/product/AutomotiveIndex.vue'
import GnssProductView from '@/views/product/automotive/gnss/GnssProductView.vue'//卫惯系列/车规级卫惯产品/GNSS详情

//卫惯系列/车规级卫惯产品/IMU模组系列index⬇️(互相跳转没有单独的index)
import ImuIndex from '@/views/product/automotive/imu/ImuIndex.vue'
import ImuProductView from '@/views/product/automotive/imu/ImuProductView.vue'//IMU????????
import PboxProductView from '@/views/product/automotive/pbox/PboxProductView.vue'//P-BOX????????
import InsProductView from '@/views/product/automotive/ins/InsProductView.vue'//INS????????



import IndustryIndex from '@/views/product/industry/IndustryIndex.vue'//卫惯系列/行业级卫惯产品index⬇️
import IndustryPositioningSeries from '@/views/product/industry/positioning/HighPrecisionPositioningSeries.vue'//卫惯系列/行业级卫惯产品/高精定位产品系列
import IndustryDomainControlSeries from '@/views/product/industry/domain-control/DrivingDomainControlTerminalSeries.vue'//卫惯系列/行业级卫惯产品/智驾域控终端系列
import IndustryProductView from '@/views/product/industry/IndustryProductView.vue'
import Software from '@/views/service/software.vue'//产品服务/软件算法

//【解决方案】

import SolutionIndex from '@/views/solution/SolutionIndex.vue'//解决方案index
import SolutionView7 from '@/views/solution/SolutionView7.vue'//智能驾驶汽车
import CollaborativeInspection from '@/views/solution/CollaborativeInspection.vue'//多源异构协同巡检
import PublicSecurityInspection from '@/views/solution/PublicSecurityInspection.vue'//安防巡检解决方案
import IndustrialInspection from '@/views/solution/IndustrialInspection.vue'//工业巡检解决方案
import TunnelCorridorInspection from '@/views/solution/TunnelCorridorInspection.vue'//隧道管廊协同探索巡检解决方案
import TraditionalMachineryOperation from '@/views/solution/TraditionalMachineryOperation.vue'//传统机械智能化作业
import AirGroundLogistics from '@/views/solution/AirGroundLogistics.vue'//空地协同物流配送

//【量产能力】
import DeliverIndex from '@/views/deliver/DeliverIndex.vue'//量产能力index

//【关于我们】
import Contact from '@/views/about/Contact.vue'//联系我们
//企业概况 -> lazy load

const routes: Array<RouteRecordRaw> = [
  // 首页
  {
    path: '/',
    name: 'home',
    component: HomeView
  },

  // 产品
  {
    path: '/product',
    redirect: '/product/automotive', // 建议添加重定向到默认子路由
    children: [
      // IMU惯性测量单元系列
      {
        path: 'imu',
        redirect: '/product/automotive/imu'
      },
      {
        path: 'imu/:productKey',
        redirect: to => `/product/automotive/imu/${to.params.productKey}`
      },
      // P-BOX卫惯组合导航系列
      {
        path: 'pbox',
        redirect: '/product/automotive/pbox'
      },
      {
        path: 'pbox/:productKey',
        redirect: to => `/product/automotive/pbox/${to.params.productKey}`
      },
      // INS卫惯组合导航系列
      {
        path: 'ins',
        redirect: '/product/automotive/ins'
      },
      {
        path: 'ins/:productKey',
        redirect: to => `/product/automotive/ins/${to.params.productKey}`
      },
      // 车规级卫惯产品
      {
        path: 'automotive',
        children: [
          {
            path: '',
            name: 'AutomotiveIndex',
            component: AutomotiveIndex
          },
          {
            path: 'ib11',
            redirect: '/product/automotive/imu/ib11'
          },
          {
            path: 'p21s',
            redirect: '/product/automotive/pbox'
          },
          {
            path: 'p22d',
            redirect: '/product/automotive/pbox/p21s'
          },
          {
            path: 'cxp-fusion',
            redirect: '/solution/smart-driving'
          },
          {
            path: 'inm11',
            redirect: '/product/automotive/ins'
          },
          {
            path: 'gnm11',
            redirect: '/product/automotive/gnss'
          },
          {
            path: 'gnm12-b',
            redirect: '/product/automotive/gnss/gnm12-b'
          },
          {
            path: 'gnm12-d',
            redirect: '/product/automotive/gnss/gnm12-d'
          },
          {
            path: 'gnm13',
            redirect: '/product/automotive/gnss/gnm13'
          },
          {
            path: 'gnm14',
            redirect: '/product/automotive/gnss/gnm14'
          },
          {
            path: 'cx005',
            redirect: '/product/automotive/gnss/cx005'
          },
          {
            path: 'gnss',
            children: [
              {
                path: '',
                name: 'GNM11',
                component: GNM11
              },
              {
                path: 'gnm12-b',
                name: 'GNM12B',
                component: GnssProductView,
                props: { productKey: 'gnm12-b' }
              },
              {
                path: 'gnm12-d',
                name: 'GNM12D',
                component: GnssProductView,
                props: { productKey: 'gnm12-d' }
              },
              {
                path: 'gnm13',
                name: 'GNM13',
                component: GnssProductView,
                props: { productKey: 'gnm13' }
              },
              {
                path: 'gnm14',
                name: 'GNM14',
                component: GnssProductView,
                props: { productKey: 'gnm14' }
              },
              {
                path: 'cx005',
                name: 'CX005',
                component: GnssProductView,
                props: { productKey: 'cx005' }
              }
            ]
          },
          // IMU模组系列
          {
            path: 'imu',
            children: [
              {
                path: '',
                name: 'ProductAutomotiveImuIndex',
                component: ImuIndex
              },
              {
                path: 'im13-m',
                name: 'ProductAutomotiveImuIM13M',
                component: ImuProductView,
                props: { productKey: 'im13-m' }
              },
              {
                path: 'im16-m',
                name: 'ProductAutomotiveImuIM16M',
                component: ImuProductView,
                props: { productKey: 'im16-m' }
              },
              {
                path: 'im18-m',
                name: 'ProductAutomotiveImuIM18M',
                component: ImuProductView,
                props: { productKey: 'im18-m' }
              },
              {
                path: 'im21',
                name: 'ProductAutomotiveImuIM21',
                component: ImuProductView,
                props: { productKey: 'im21' }
              },
              {
                path: 'ib11',
                name: 'ProductAutomotiveImuIB11',
                component: ImuProductView,
                props: { productKey: 'ib11' }
              },
              {
                path: 'im11',
                redirect: '/product/automotive/imu/im13-m'
              },
              {
                path: 'im12',
                redirect: '/product/automotive/imu/im18-m'
              },
              {
                path: 'im13',
                redirect: '/product/automotive/imu/im13-m'
              },
              {
                path: 'im15',
                redirect: '/product/automotive/imu/im16-m'
              }
            ]
          },
          // P-BOX卫惯组合导航系列
          {
            path: 'pbox',
            children: [
              {
                path: '',
                name: 'ProductAutomotivePboxIndex',
                component: P21S
              },
              {
                path: 'p21s',
                name: 'ProductAutomotivePboxP21S',
                component: PboxProductView,
                props: { productKey: 'p21s' }
              }
            ]
          },
          // INS卫惯组合导航系列
          {
            path: 'ins',
            children: [
              {
                path: '',
                name: 'ProductAutomotiveInsIndex',
                component: INM11
              },
              {
                path: 'inm13-s1',
                name: 'ProductAutomotiveInsINM13S1',
                component: InsProductView,
                props: { productKey: 'inm13-s1' }
              },
              {
                path: 'inm14',
                name: 'ProductAutomotiveInsINM14',
                component: InsProductView,
                props: { productKey: 'inm14' }
              }
            ]
          }
        ]
      },
      // 行业级卫惯产品
      {
        path: 'industry',
        children: [
          {
            path: '',
            name: 'IndustryIndex',
            component: IndustryIndex
          },
          {
            path: 'positioning',
            name: 'IndustryPositioningSeries',
            component: IndustryPositioningSeries
          },
          {
            path: 'positioning/:productKey',
            name: 'IndustryPositioningProduct',
            component: IndustryProductView,
            props: true
          },
          {
            path: 'domain-control',
            name: 'IndustryDomainControlSeries',
            component: IndustryDomainControlSeries
          },
          {
            path: 'domain-control/:productKey',
            name: 'IndustryDomainControlProduct',
            component: IndustryProductView,
            props: true
          },
          {
            path: 'i10',
            redirect: '/product/industry/positioning/i10'
          },
          {
            path: 'ix10',
            redirect: '/product/industry/positioning/ix10'
          },
          {
            path: 'p100a',
            redirect: '/product/industry/positioning/p100a'
          },
          {
            path: 'p200a',
            redirect: '/product/industry/positioning/p200a'
          },
          {
            path: 'dc100',
            redirect: '/product/industry/domain-control/dc100'
          },
          {
            path: 'dc200',
            redirect: '/product/industry/domain-control/dc200'
          },
          {
            path: 'cxgy10',
            redirect: '/product/industry/positioning/i10'
          },
          {
            path: 'cxgy20',
            redirect: '/product/industry/positioning/ix10'
          },
          {
            path: 'cxgy30',
            redirect: '/product/industry/positioning/i10'
          },
          {
            path: 'cxgy50',
            redirect: '/product/industry/positioning/p100a'
          },
          {
            path: 'cxgy110',
            redirect: '/product/industry/positioning/ix10'
          },
          {
            path: 'cxgy150',
            redirect: '/product/industry/positioning/p200a'
          },
          {
            path: 'cxgyb10',
            redirect: '/product/industry/positioning'
          },
          {
            path: 'cxgyb110',
            redirect: '/product/industry/positioning'
          },
          {
            path: 'cxgyb120',
            redirect: '/product/industry/positioning'
          },
          {
            path: 'cxgyb130',
            redirect: '/product/industry/positioning'
          }
        ]
      }
    ]
  },

  // 服务
  {
    path: '/service',
    redirect: '/service/software',
    children: [
      {
        path: 'algorithm',
        redirect: '/product/industry/domain-control'
      },
      {
        path: 'smart-cockpit',
        redirect: '/product/industry/domain-control'
      },
      {
        path: 'software',
        name: 'SoftwareAlgorithm',
        component: Software
      },
      {
        path: 'software-algorithm',
        redirect: '/service/software'
      }
    ]
  },

  // 解决方案
  {
    path: '/solution',
    children: [
      {
        path: '',
        name: 'SolutionIndex',
        component: SolutionIndex
      },
      {
        path: 'low-speed-vehicle',
        redirect: '/solution'
      },
      {
        path: 'smart-robot',
        redirect: '/solution'
      },
      {
        path: 'engineering-machinery',
        redirect: '/solution/traditional-machinery-intelligent-operation'
      },
      {
        path: 'agricultural-machinery',
        redirect: '/solution/traditional-machinery-intelligent-operation'
      },
      {
        path: 'uav',
        redirect: '/solution/air-ground-collaboration'
      },
      {
        path: 'port-shipping',
        redirect: '/solution'
      },
      {
        path: 'smart-driving',
        name: 'SolutionView7',
        component: SolutionView7
      },
      {
        path: 'collaborative-inspection',
        name: 'CollaborativeInspection',
        component: CollaborativeInspection
      },
      {
        path: 'smart-surveying',
        redirect: '/solution'
      },
      {
        path: 'public-security-inspection',
        name: 'PublicSecurityInspection',
        component: PublicSecurityInspection
      },
      {
        path: 'industrial-inspection',
        name: 'IndustrialInspection',
        component: IndustrialInspection
      },
      {
        path: 'tunnel-corridor-inspection',
        name: 'TunnelCorridorInspection',
        component: TunnelCorridorInspection
      },
      {
        path: 'traditional-machinery-intelligent-operation',
        name: 'TraditionalMachineryOperation',
        component: TraditionalMachineryOperation
      },
      {
        path: 'air-ground-collaboration',
        name: 'AirGroundLogistics',
        component: AirGroundLogistics
      }
    ]
  },

  // 量产能力
  {
    path: '/deliver',
    name: 'DeliverIndex',
    component: DeliverIndex
  },

  // 公司动态
  {
    path: '/news',
    redirect: '/about'
  },

  // 关于我们
  {
    path: '/about',
    children: [
      {
        path: '',
        name: 'about',
        component: () => import(/* webpackChunkName: "about" */ '@/views/about/AboutView.vue')
      },
      {
        path: 'contact',
        name: 'Contact',
        component: Contact
      }
    ]
  },
]
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return { el: to.hash, top: 96 }
    }

    return savedPosition || { top: 0 }
  }
})

if (typeof window !== 'undefined' && 'scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual'
}

// 添加全局导航守卫
router.beforeEach((to, from, next) => {
  // 检查是否有匹配的路由
  if (to.matched.length === 0) {
    // 如果没有匹配的路由，重定向到首页
    next({ path: '/' })
  } else {
    // 存在匹配的路由，正常导航
    next()
  }
})

export default router
